<template>
  <v-card class="c dashboard-workload is-absolute" :class="{'is-extended': extended}">
    <v-card-title primary-title>
      <h4 class="headline">{{ label }}</h4>
    </v-card-title>
    <v-card-text>
      <v-progress-circular
        :rotate="rotate"
        :size="size"
        :width="width"
        :value="(workload / maxVal) * 100"
        :color="color"
      >
        <span v-if="icon">
          <v-icon>{{ icon }}</v-icon>
        </span>
        <count-to :startVal="startVal" :endVal="endVal" :duration="1500"></count-to>/ {{ maxVal }}
      </v-progress-circular>
      <div v-if="extended" class="slot">
        <slot></slot>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import CountTo from 'vue-count-to';

export default {
  name: 'workload',

  components: {
    CountTo,
  },

  props: {
    workload: {
      type: Number,
      required: true,
    },
    maxVal: {
      type: Number,
      required: true,
    },
    rotate: {
      type: Number,
      default: 270,
    },
    width: {
      type: Number,
      default: 12,
    },
    size: {
      type: Number,
      default: 200,
    },
    color: {
      type: String,
      default: 'primary',
    },
    label: {
      type: String,
      default: 'Aktuelle Auslastung',
    },
    icon: {
      type: [String, Boolean],
      default: false,
    },
    extended: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      startVal: 0,
      endVal: this.workload,
    };
  },

  watch: {
    workload(newVal, oldVal) {
      this.startVal = oldVal;
      this.endVal = newVal;
      if (newVal !== oldVal) {
        this.$el.classList.add('has-changed');
        setTimeout(() => {
          this.$el.classList.remove('has-changed');
        }, 1000);
      }
    },
  },
};
</script>
